#import "../fragments/sales-document-fragment.graphql"

mutation UpdateSalesDocument($input: SalesDocumentUpdateInput!) {
    salesDocumentUpdate(input: $input) {
        salesDocument {
            ...SalesDocumentFragment
        }
    }
}
